import AuthenticationService from '@/services/AuthenticationService'
import PlanningService from '@/services/PlanningService'
import ProfileService from '@/services/ProfileService'
import TaskService from '@/services/TaskService'
export default {
	reset ({ commit }) {
		commit('reset')
	},
	login ({ commit, dispatch }, payload) {
		commit('login', payload)
		dispatch('getPlannings')
		dispatch('getFriends')
	},
	logout ({ commit }) {
		commit('setPlannings', null)
		commit('setFriends', null)
		commit('setFriendRequests', null)
		commit('logout')
	},
	async updateUser (context, user) {
		context.commit('setUser', { user })
	},
	// Settings
	toggleDarkMode ({ commit }) {
		commit('toggleDarkMode')
	},
	toggleWeekView ({ commit }) {
		commit('toggleWeekView')
	},
	// Modals
	openModal ({ commit }, content) {
		commit('openModal', content)
	},
	closeModal ({ commit }) {
		commit('closeModal')
	},
	openDiscussion ({ commit }) {
		commit('openModal')
		commit('setModalContent', 'Discussion')
	},
	openPopup ({ commit }, info) {
		commit('openModal', { component: 'Popup', info })
	},
	// Planning
	async getPlannings (context) {
		// If not correctly logged in, logout the user
		if (!context.state.authentication.user) AuthenticationService.logout()
		const plannings = await PlanningService.getAll({
			includeTasks: true,
			includeTopics: true,
			user: context.state.authentication.user.id
		})
		context.commit('setPlannings', plannings)
	},
	async toggleTask (context, payload) {
		await TaskService.toggle(payload)
		const plannings = context.state.plannings
		if (!plannings) return
		const planningIndex = plannings.findIndex(planning => planning.id === payload.planningId)
		const planning = plannings[planningIndex]
		if (!payload.parent) {
			// Handling a regular task
			const taskIndex = planning.Tasks.findIndex(task => task.id === payload.taskId)
			context.commit('toggleTask', {
				planningIndex,
				taskIndex,
				done: payload.done
			})
		} else {
			// Handling a child task
			const parentIndex = planning.Tasks.findIndex(task => task.id === payload.parent)
			const childIndex = planning.Tasks[parentIndex].ChildTasks.findIndex(task => task.id === payload.taskId)
			context.commit('toggleTask', {
				planningIndex,
				parentIndex,
				taskIndex: childIndex,
				done: payload.done
			})
		}
	},
	// Socials
	async getFriends (context) {
		// If not correctly logged in, logout the user
		if (!context.state.authentication.user) AuthenticationService.logout()
		const friends = await ProfileService.getFriends(context.state.authentication.user.username)
		context.commit('setFriends', friends)
		const friendRequests = await ProfileService.getFriendRequests()
		context.commit('setFriendRequests', friendRequests)
	}
}
